import {persistedChatSnapshotSchema} from '../persistence.schemas';
import {PersistedChatSnapshot} from '../persistence.types';

export type SnapshotValidationResult =
  | {success: true; data: PersistedChatSnapshot}
  | {success: false; error: string};

export default function validateSnapshot(data: unknown): SnapshotValidationResult {
  const result = persistedChatSnapshotSchema.safeParse(data);

  if (result.success) {
    return {success: true, data: result.data as PersistedChatSnapshot};
  }

  const issues = result.error.issues.map((issue) => issue.message).join('\t|\t');

  const path = result.error.issues[0].path.join('.');

  return {
    success: false,
    error: path ? `Invalid "${path}": ${issues}` : issues,
  };
}
